<div class="water-app-wrapper">
    <div class="iframe-container">
      <iframe 
        [src]="waterUrl | safeUrl"
        allowfullscreen>
      </iframe>
    </div>
  </div>
